import { LoggerService } from "@Front/Services/LoggerService/LoggerService";

/**
 * Full-page navigation when Next soft-nav updates history without remounting the target page
 * (stable dashboard shell — same class as create-folder 513 / deed-types crayon 516).
 */
export function hardClientNavigate(href: string, context: string): void {
	LoggerService.info("🔄 [hardClientNavigate] Hard navigation", { href, context });
	window.location.assign(href);
}
